export default __webpack_public_path__ + "static/media/smiler.b046d991.svg";